<script>
import SubDivisions from "../data/SubDivision"
import Divisions from "../data/Divisions"
import {USStates, IndianStates} from "../data/States"
import Cropper from 'svelte-easy-crop'
import {createEventDispatcher} from "svelte"
import {files, api}from "../../store"
import {Countries, States} from "../data/Countries"
    
let api_url
api.subscribe(value => (api_url = value))
export let fetchAction
export let MFS 

let file
files.subscribe((value) => {
   file = value
})

let display = createEventDispatcher()

$:if (fetchAction == "update") {
   fetch(`${file}${MFS.photo}`)
   fetch(`${file}${MFS.horoscope}`)
}

function submit() {
   let sendData = new FormData()
   let loginDatum = JSON.parse(localStorage.getItem('loginData'))
   sendData.append("info", JSON.stringify({...MFS, photo:"", horoscope:""}))
   

   if (fetchAction != "update") {
      sendData.append("photo", MFS.photo[0] )
   sendData.append("horoscope",  MFS.horoscope[0])
   }
   sendData.append(fetchAction,  "true")
   if (fetchAction == "update") {
      sendData.append("id",  MFS.id)
   }
   sendData.append('master', loginDatum.email)
   fetch(`${api_url}matrimonial.php`, {
      method: "POST",
      body:sendData
   })
   .then(res => {
      display("formUpdate")
   })
}

  let crop = { x: 0, y: 0 }
  let zoom = 1

</script>


{#if MFS}
<main>
   <form on:submit|preventDefault={()=>submit()} class="ds-form">
     
     <div class="ds-form-title">
        <h1>Matrimonial Registration Form - {fetchAction}</h1>
        <p>All fields with (*) in this form, are required. please fill all fields</p>
     </div>

      <div class="ds-form-container">

        <div class="ds-container">
           <lable>Gender*</lable>
           <select bind:value={MFS.gender}>
              <option value="Female">Female</option>
              <option value="Male">Male</option>
              
           </select>
        </div>

        <div  class="ds-container">
           <lable>Full Name*</lable>
           <input maxlength="225" required bind:value={MFS.full_name} type="text"> 
        </div>

        
        <div  class="ds-container-special">
           <lable>Current Address*</lable>
           <input maxlength="225" required bind:value={MFS.current_address_address} type="text" placeholder="Address">
           <input maxlength="225" required bind:value={MFS.current_address_city} type="text" placeholder="City"> 
           <select bind:value={MFS.current_address_country} >
            {#each Countries as country }
            <option value={country}>{country}</option>
            {/each}
              
           </select>
       
           <select bind:value={MFS.current_address_state}   >
            <option value="">Select State</option>
            {#if MFS.current_address_country}
            
              {#each States[MFS.current_address_country] as state}
                <option value={state}>{state}</option>
              {/each} 
   
            {/if}
           </select>

       
           <input maxlength="225" bind:value={MFS.current_address_zip_code} required type="number" placeholder="Zip Code"> 
        </div>
   


        <div  class="ds-container-special">
           <lable>Native Address*</lable>
           <input maxlength="225" required bind:value={MFS.native_address_address} type="text" placeholder="Address">
           <input maxlength="225" required bind:value={MFS.native_address_city} type="text" placeholder="City">


           <select bind:value={MFS.native_address_country} >
            {#each Countries as country }
            <option value={country}>{country}</option>
            {/each}
            </select>
            <select bind:value={MFS.native_address_state}   >
               <option value="">Select State</option>
               {#if MFS.native_address_country}
               
                 {#each States[MFS.native_address_country] as state}
                   <option value={state}>{state}</option>
                 {/each} 
      
               {/if}
              </select>
   
    



           
           <input maxlength="225" bind:value={MFS.native_address_zip_code} required type="number" placeholder="Zip Code"> 
        </div>
   


        <div  class="ds-container">
           <lable>Contact</lable>
           <input maxlength="225" bind:value={MFS.contact} type="text"> 
        </div>

        <div  class="ds-container">
           <lable>Email</lable>
           <input maxlength="225" bind:value={MFS.email} type="text"> 
        </div>

        <div  class="ds-container">
           <lable>Education</lable>
           <input maxlength="225" bind:value={MFS.education} type="text"> 
        </div>

        <div  class="ds-container">
           <lable>Working</lable>
           <select bind:value={MFS.working} >
            <option value="yes">Yes</option>
            <option value="no">No</option>
         </select>
        </div>

        <div  class="ds-container">
           <lable>Work Location</lable>
           <input maxlength="225" bind:value={MFS.work_location} type="text"> 
        </div>

        <div  class="ds-container">
           <lable>Salary</lable>
           <input maxlength="225" bind:value={MFS.salary} type="text"> 
        </div>

        <div  class="ds-container">
           <lable>Zodiac Star</lable>
           <input maxlength="225" bind:value={MFS.zodiac_star} type="text"> 
        </div>

        <div  class="ds-container">
         <lable>Age</lable>
         <input maxlength="225" bind:value={MFS.age} type="number"> 
      </div>

        <div  class="ds-container">
           <lable>Caste*</lable>
           <select bind:value={MFS.caste}>
              <option value="Kannada Devaga Chettiyar">Kannada Devaga Chettiyar
              </option>
              <option value="Telugu Devaga Chettiyar">Telugu Devaga Chettiyar</option>
           </select>
        </div>

        <div  class="ds-container">
           <lable>Divisions*</lable>
           <select bind:value={MFS.division}>
            {#each Divisions as Division}
            <option value={Division}>{Division}</option>
            {/each}
           </select>
        </div>

        <div  class="ds-container">
           <lable>Sub Divisions*</lable>
           <select bind:value={MFS.sub_division}>
            {#each SubDivisions as SubDivision}
            <option value={SubDivision}>{SubDivision}</option>
            {/each}
           </select>
        </div>

       


       

        <div  class="ds-container">
           <lable>Contact Person*</lable>
           <input maxlength="225" required bind:value={MFS.contact_person} type="text"> 
        </div>


        <div  class="ds-container">
           <lable>Contact Person Phone*</lable>
           <input maxlength="225" required bind:value={MFS.contact_person_phone} type="number"> 
        </div>


        <div  class="ds-container">
           <lable>Contact Person Email*</lable>
           <input maxlength="225" required bind:value={MFS.contact_person_email} type="email"> 
        </div>

        
{#if fetchAction != "update"}
   
<div class="ds-container ds-file">
   <lable>Horoscope*</lable>
   <input  bind:files={MFS.horoscope} accept="image/png, image/jpeg" type="file"> 
</div>


<div class="ds-container ds-file">
   <lable>Photo*</lable>
   <input bind:files={MFS.photo} accept="image/png, image/jpeg" required type="file"> 
</div>

{/if}

<div  class="ds-container-long">
   <lable>Special Mention (Max. 255 Characters)</lable>

   <input maxlength="225" rows="3" bind:value={MFS.special_mention} aria-multiline="true" type="text"> 
</div>

      </div>
      <div class="ds-submit">
        <button type="submit">submit</button>
     </div>
    </form>
    
</main>
{/if}


<style lang="scss">
@import "../scss/Config.scss";
main {
   background-color: rgba(0, 0, 0, 0.413);
   padding: 2.5%;
   margin-bottom: 5vh;
}

.ds-form-title {
   text-align: center;
   p {
      color: red;
   }
}

.ds-submit {
            width: 95%;
            margin: auto;
            display: flex;
            justify-content: center;

            button {
               all: unset;
               width: 50%;
               max-width: 126px;
               padding: 10px;
               text-align: center;
               background-color: #FF9933;
               box-shadow: 1px 1px 5px #000;
               transition:box-shadow ease 0.3s ;

               &:active {
                  box-shadow: 0px 0px 1px #000;
               }
            }
         }
     .ds-form{
        width: 90%;
        margin: 0% auto 5% auto;
        height: 100%;
        background-color: #fff;
        padding: 5%;

        select, 
        input {
               // height: 5vh;
               // min-height: 30px;
               width: 100%;
               height: unset;
               aspect-ratio: 10;
            }

        .ds-form-container {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            

         .ds-container{
            margin:1% 2.5%;
            display:flex ;
            justify-content: left;
            flex-direction: column;
            width: 45%;
            @include mobile {
               margin-top: 3vh;
               width: 95%;
            }
         }
         .ds-container-long{
            margin:1% 2.5%;
            display:flex ;
            justify-content: left;
            flex-direction: column;
            width: 100%;
         }
         .ds-file {
            border: #000 1px solid;
            padding: 2%;
         }
         .ds-container-special{
            margin: 1% 2.5%;
            width: 45%;
            display:flex ;
            justify-content: left;
            flex-direction: column;
            border: 2px #000 solid;
            padding: 2%;
            border-radius: 5px;

            * {
               margin-top: 2%;
               
            }

            @include mobile {
               margin-top: 1vh;
               width: 95%;
            }
         }

         


        }
        

        
     }
     
</style>